export const sanitizeLatexContent = (content: string): string => {
    if (!content) return content
  
    // Step 1: Protect math expressions between $ delimiters
    const mathExpressions: string[] = []
    let protectedContent = content.replace(/\$([^$]+?)\$/g, (match, inner) => {
      // Exclude if contains common English words
      const hasRegularWords = /\b(the|is|and|or|with|for|at|to|in|on|by|an|a|are|was|were|be|been|have|has|had|do|does|did|will|would|could|should|may|might|must|can|shall)\b/i.test(inner)
      
      // Exclude if has 4+ consecutive letters (likely regular text, not math)
      // But don't count letters that are part of LaTeX commands (after backslash)
      const innerWithoutLatex = inner.replace(/\\[a-zA-Z]+/g, "")
      const hasManyLetters = /[a-zA-Z]{4,}/.test(innerWithoutLatex)
      
      if (hasRegularWords || hasManyLetters) {
        return match
      }
      
      // Math indicators: operators (+,-,*,/,=,<,>,^,_,{},\), LaTeX commands (\frac, \sqrt, etc.)
      const hasMathOperators = /[+\-*/=<>^_{}\\]/.test(inner)
      const hasNumbers = /\d/.test(inner)
      const isSingleVariable = /^[a-zA-Z]$/.test(inner.trim())
      const hasLatexCommands = /\\(frac|sqrt|sum|int|lim|sin|cos|tan|log|ln|exp|alpha|beta|gamma|delta|theta|pi|sigma|times|cdot|div|pm|infty|leq|geq|neq|approx|equiv)/.test(inner)
      const looksLikeEquation = /[a-zA-Z0-9]\s*[+\-*/=]\s*[a-zA-Z0-9]/.test(inner)
      
      const looksLikeMath = isSingleVariable || hasLatexCommands || looksLikeEquation || 
                           (hasNumbers && hasMathOperators) ||
                           (hasNumbers && /[a-zA-Z]/.test(inner) && inner.length < 20)
      
      if (looksLikeMath) {
        mathExpressions.push(match)
        return `__MATH_EXPR_${mathExpressions.length - 1}__`
      }
      
      return match
    })
    
    // Step 2: Protect already-escaped dollars (\$ becomes \\$ for ReactMarkdown)
    const escapedDollars: string[] = []
    protectedContent = protectedContent.replace(/\\\$/g, () => {
      escapedDollars.push("\\\\$")
      return `__ESCAPED_DOLLAR_${escapedDollars.length - 1}__`
    })
    
    // Step 3: Escape currency ($ followed by digits, with optional commas and decimals)
    // ReactMarkdown needs \\$ to render as \$
    protectedContent = protectedContent.replace(
      /\$(\d+(?:,\d{3})*(?:\.\d+)?)(?![a-zA-Z0-9])/g,
      (_match, amount) => `\\\\$${amount}`
    )
    
    // Step 4: Restore placeholders
    escapedDollars.forEach((dollar, index) => {
      protectedContent = protectedContent.replace(`__ESCAPED_DOLLAR_${index}__`, dollar)
    })
    
    mathExpressions.forEach((expr, index) => {
      protectedContent = protectedContent.replace(`__MATH_EXPR_${index}__`, expr)
    })
    
    content = protectedContent
    
    // Fix over-escaped dollars: 3+ backslashes become 2
    content = content.replace(/\\{3,}\$/g, "\\\\$")
    
    // Convert escaped newlines to actual newlines
    content = content.replace(/\\\\n/g, "\n")
    
    return content
  }